import React from 'react';
import type { TypographyDefinition, TypographyId } from './typography';

export interface TypographyContextValue {
  typographyId: TypographyId;
  typography: TypographyDefinition;
  typographyList: TypographyDefinition[];
  setTypography: (id: TypographyId) => void;
}

export const TypographyContext = React.createContext<TypographyContextValue | undefined>(undefined);
